import LinearProgress from '@material-ui/core/LinearProgress';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { IActiveUpload } from '../../ducks/files';

interface IActiveUploadListItemProps {
  file: IActiveUpload;
}

export const ActiveUploadListItem = React.memo<IActiveUploadListItemProps>(({ file }) => {
  return (
    <ListItem>
      <ListItemText
        disableTypography
        primary={<Typography variant="subtitle1">{file.name}</Typography>}
        secondary={<LinearProgress color="secondary" variant="determinate" value={file.progress} />}
      />
    </ListItem>
  );
});
